import { useFormContext } from 'react-hook-form';
import {
  GroupType,
  OptionType,
} from '../../../../../../../../CommonComponents/OPL/Select/BaseSelect/types';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { OwnerModelDTO } from '../../../../../../api/useAccountsQuery';

export const useAccountOwnership = () => {
  const { watch } = useFormContext();

  const accountType = watch('bankAccount.AccountType');

  const {
    options: { OwnerOptions, IndividualOwnerOptions, JointOwnerOptions, AccountTypeOptions },
  } = useAccountFormContext();

  const accountOptions = AccountTypeOptions.find(option => option.AccountType === accountType);

  const hasJointOptions = accountOptions?.AllowsJointOwnership;
  const hasTrustOptions = accountOptions?.AllowsTrustOwnership;

  const getOptions = () => {
    if (!hasJointOptions && !hasTrustOptions) {
      return IndividualOwnerOptions;
    }

    if (hasJointOptions) {
      return JointOwnerOptions;
    }

    if (!hasTrustOptions) {
      return IndividualOwnerOptions;
    }

    return OwnerOptions;
  };

  const ownerOptions = getOptions();

  return {
    options: Object.keys(ownerOptions).map(key => ({
      label: key,
      options: (ownerOptions[key] || []).map((owner, ind) => ({
        value: owner.Id,
        label: owner.Name,
      })),
    })) as GroupType<OptionType<string>>[],
    ownerOptions: Object.keys(ownerOptions)
      .map(key => ownerOptions[key])
      .flat() as OwnerModelDTO[],
    allowsUnequalOwnership: accountOptions ? accountOptions.AllowsUnequalOwnership : false,
  };
};
